export * from './confirmation.component';



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/confirmation/index.ts